import TemplateView from "../../../TemplateView";

export default class NonGroupBlock extends TemplateView {
    constructor(items = []) {
        super();
        this.items = items;
    }

    templateHtml() {
        return "<div class='nonGroupSection components_itemGroup'>" +
               "  <div class='items'></div>" +
               "</div>"
    }

    afterRender() {
        const $items = this.find(".items");
        this.items.forEach(item => item.init($items));
    }
}


// WEBPACK FOOTER //
// ./web/js/panels/usersAssignedToHierarchy/usersList/NonGroupBlock.js